'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import StoredVideoContainer from '../../containers/StoredVideoContainer';
import VideoControlsContainer from '../../containers/VideoControlsContainer';
import ContentControlWrapper from '../ContentControlWrapper';

class StoredVideoWithControls extends PureComponent {
  render() {
    const {
      contentId,
      onFinish,
      lessonId,
      lessonName,
      trackId,
      trackName
    } = this.props;
    return /*#__PURE__*/_jsx(StoredVideoContainer, {
      contentId: contentId,
      lessonId: lessonId,
      lessonName: lessonName,
      onFinish: onFinish,
      trackId: trackId,
      trackName: trackName,
      children: /*#__PURE__*/_jsx(ContentControlWrapper, {
        children: /*#__PURE__*/_jsx(VideoControlsContainer, {
          onFinish: onFinish
        })
      })
    });
  }

}

StoredVideoWithControls.propTypes = {
  contentId: PropTypes.string,
  lessonId: PropTypes.string,
  lessonName: PropTypes.string,
  onFinish: PropTypes.func,
  trackId: PropTypes.string,
  trackName: PropTypes.string
};
export default StoredVideoWithControls;